<template>
  <div
    class="
      h-screen
      flex
      w-full
      bg-img
      vx-row
      no-gutter
      items-center
      justify-center
    "
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row no-gutter justify-center items-center">
            <div class="vx-col hidden lg:block lg:w-1/2">
              <img
                width="200"
                src="@/assets/images/logo/logosiyah.png"
                alt="login"
                class="mx-auto"
              />
            </div>

            <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
              <div class="p-8 login-tabs-container">
                <div class="vx-card__title mb-4">
                  <h4 class="mb-4">{{ $t("login") }}</h4>
                </div>

                <div class="mt-base">
                  <vs-input
                    name="email"
                    icon-no-border
                    icon="icon icon-user"
                    icon-pack="feather"
                    :label-placeholder="$t('email')"
                    v-model="obj.EmailOrUserName"
                    class="w-full"
                  />

                  <vs-input
                    type="password"
                    name="password"
                    icon-no-border
                    icon="icon icon-lock"
                    icon-pack="feather"
                    :label-placeholder="$t('password')"
                    v-model="obj.Password"
                    class="w-full mt-base"
                    @keypress.enter="login"
                  />

                  <div class="flex flex-wrap justify-between my-5">
                    <vs-checkbox v-model="checkbox_remember_me" class="mb-3"
                      >Beni Hatırla</vs-checkbox
                    >
                    <router-link to="/forgot-password">{{
                      $t("forgetPassword")
                    }}</router-link>
                  </div>
                  <!-- <vs-button @click="$router.push('/register')" type="border">Kayıt Ol</vs-button> -->
                  <vs-button @click="login" class="float-right mb-5"
                    >Giriş</vs-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import http from "../../http/http-helper";

export default {
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        document.title = to.meta.title;
      },
    },
  },
  data() {
    return {
      obj: {
        EmailOrUserName: "",
        Password: "",
      },
      checkbox_remember_me: false,
    };
  },
  methods: {
    // Login
    login() {
      if (this.obj.EmailOrUserName == "" || this.obj.Password == "")
        return this.$vs.notify({
          title: "Uyarı",
          text: "Lütfen Email ve Şifre Giriniz",
          color: "warning",
        });
      //this.$vs.loading();
      let path = "/auth/login";
      http.post(path, this.obj).then(async (response) => {
        await localStorage.setItem("token", response.accessToken.token);
        await localStorage.setItem(
          "expiration",
          response.accessToken.expiration
        );
        await localStorage.setItem(
          "role",
          response.accessToken.roles[0].claimName
        );
        await localStorage.setItem("userId", response.id);
        await localStorage.setItem("lang", navigator.language);
        this.$store.state.token = response.accessToken.token;
        this.$store.state.expiration = response.accessToken.expiration;
        this.$store.state.role = response.accessToken.roles[0].claimName;
        this.$store.state.userId = response.id;
        this.$store.state.language = navigator.language;
        await localStorage.setItem(
          "AppActiveUser",
          JSON.stringify({
            id: response.id,
            firstName: response.firstName,
            lastName: response.lastName,
            email: response.email,
          })
        );
        this.$store.state.AppActiveUser = {
          id: response.id,
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.email,
        };
        this.$router.push("/home");
      });
    },
  },
};
</script>

<style lang="scss">
#page-login {
  .social-login-buttons {
    .bg-facebook {
      background-color: #1551b1;
    }
    .bg-twitter {
      background-color: #00aaff;
    }
    .bg-google {
      background-color: #4285f4;
    }
    .bg-github {
      background-color: #333;
    }
  }
}
</style>
